import { Component, OnInit, Input } from '@angular/core';
import { NgbModalRef, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { HistoryModalComponent } from '../history-modal/history-modal.component';
import { environment } from 'src/environments/environment';

import * as _ from 'lodash';
import * as xml from 'xml-js';

@Component({
    selector: 'app-message-history',
    templateUrl: './message-history.component.html',
    styleUrls: ['./message-history.component.scss'],
    standalone: false
})
export class MessageHistoryComponent implements OnInit {
  @Input() history = { error: null, messages: [] };
  @Input() loading: boolean;
  @Input() isCollapsed: boolean;

  public modal: NgbModalRef;

  constructor(private modalService: NgbModal) {}

  ngOnInit() {
    if (environment.environment !== 'Production') {
      this.generateQAHelper();
    }
  }

  public openModal(record: any) {
    const modal = this.modalService.open(HistoryModalComponent, { size: 'lg' });
    modal.componentInstance.message = record.message;
  }

  // TODO: Remove this method.
  private generateQAHelper() {
    try {
      if (this.history && this.history.messages) {
        const messages = this.history.messages;

        let boarded = _.find(messages, {
          source: 'SOA-BOARDEDPAX',
          type: 'Inbound'
        }).message;

        boarded = JSON.parse(boarded);

        let checkedIn = _.find(messages, {
          source: 'SOA-CHECKEDINPAX',
          type: 'Inbound'
        }).message;

        checkedIn = JSON.parse(checkedIn);

        const standby = _.find(messages, {
          source: 'SOA-STANDBYPAX',
          type: 'Inbound'
        }).message;

        let standbyJSON: any = xml.xml2json(standby);
        standbyJSON = JSON.parse(standbyJSON);

        const stbyRecords = standbyJSON.elements[0].elements.filter(item =>
          item.name.includes('StandbyData')
        );

        const standbyBreakdown = {};

        stbyRecords.forEach(item => {
          if (standbyBreakdown[item.attributes.Group]) {
            standbyBreakdown[item.attributes.Group] += +item.attributes
              .NumberOfPassengers;
          } else {
            standbyBreakdown[item.attributes.Group] = +item.attributes
              .NumberOfPassengers;
          }
        });

        console.log('PAX QA HELPER');
        console.log({
          boarded: {
            adult: boarded.pasengerTypeCodeCounts[0].passengerCnt,
            child: boarded.pasengerTypeCodeCounts[1].passengerCnt,
            'adult-infant': boarded.pasengerTypeCodeCounts[2].passengerCnt,
            infant: boarded.pasengerTypeCodeCounts[3].passengerCnt,
            total: boarded.totalPassengerCnt
          },
          checkedin: {
            adult: checkedIn.pasengerTypeCodeCounts[0].passengerCnt,
            child: checkedIn.pasengerTypeCodeCounts[1].passengerCnt,
            'adult-infant': checkedIn.pasengerTypeCodeCounts[2].passengerCnt,
            infant: checkedIn.pasengerTypeCodeCounts[3].passengerCnt,
            total: checkedIn.totalPassengerCnt
          },
          standby: standbyBreakdown
        });
      }
    } catch {
      console.log('Not all data was available display PAX QA HELPER');
    }
  }
}
